import React, { FormEvent, useState } from "react";
import { Link } from "react-router-dom";
import { useForgotPasswordMutation } from "../../store/api/authApi";
import "./AuthPage.css";

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError("");
    if (!email.trim()) { setError("Please enter your email address."); return; }
    try {
      await forgotPassword(email.trim()).unwrap();
      setSent(true);
    } catch {
      setError("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        {/* Brand */}
        <div className="auth-brand">
          <div className="auth-brand-icon">
            <i className="bi bi-shield-lock-fill" />
          </div>
          <div>
            <div className="auth-brand-name">Dialin24</div>
            <div className="auth-brand-sub">Admin Portal</div>
          </div>
        </div>

        {sent ? (
          /* ── Success state ── */
          <div className="auth-success">
            <div className="auth-success-icon">
              <i className="bi bi-envelope-check-fill" />
            </div>
            <h2 className="auth-title">Check your email</h2>
            <p className="auth-copy">
              If an account with <strong>{email}</strong> exists, we've sent a
              password reset link. Check your inbox (and spam folder).
            </p>
            <p className="auth-copy" style={{ fontSize: "0.82rem" }}>
              The link expires in <strong>1 hour</strong>.
            </p>
            <Link to="/admin" className="btn auth-submit-btn w-100 mt-3">
              Back to Login
            </Link>
          </div>
        ) : (
          /* ── Form state ── */
          <>
            <h2 className="auth-title">Forgot your password?</h2>
            <p className="auth-copy">
              Enter the email address linked to your admin account and we'll
              send you a reset link.
            </p>

            <form onSubmit={handleSubmit} noValidate>
              <div className="auth-field">
                <label htmlFor="fpEmail" className="auth-label">
                  Email address
                </label>
                <div className="auth-input-wrap">
                  <i className="bi bi-envelope auth-input-icon" />
                  <input
                    id="fpEmail"
                    type="email"
                    className="auth-input"
                    placeholder="admin@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="email"
                    required
                  />
                </div>
              </div>

              {error && <div className="auth-error">{error}</div>}

              <button
                type="submit"
                className="btn auth-submit-btn w-100"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" />
                    Sending…
                  </>
                ) : (
                  <>
                    <i className="bi bi-send me-2" />
                    Send Reset Link
                  </>
                )}
              </button>
            </form>

            <p className="auth-footer-link">
              <Link to="/admin">
                <i className="bi bi-arrow-left me-1" />
                Back to Login
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
